export const formatActivityOrder = (order: string) => (value: string) => {
  return value === order;
};

export const parseActivityOrder = (order: string) => () => {
  return order;
};
